export default __webpack_public_path__ + "static/media/linkSeguroFundo.aab398af.jpg";